import styled from 'vue-styled-components'

export default styled.div`
    & .sync-validator-options  {
        display: flex;
        flex-direction: column;
        & .sync-validator-item {
            display: flex;
            align-items: center;
            padding: 10px 0;
            & .circle {
                background-color: #2196f3;
                &.success {
                    background-color: #00ad1d;
                }
                &.error {
                    background-color: #f40808;
                }
                color: #FFFFFF;
                border-radius: 100%;
                width: 30px;
                height: 30px;
                position: relative;
                & .mdi {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }
            }
            & .label {
                color: #2a2a2a;
                margin: 0;
                margin-left: 15px;
            }
        }
    }
`;
